import { type ConfigInterface } from '../util/core/config/config.interface'

export const environment: ConfigInterface = {
  production: false,
  SEARCH_API: 'https://test-search.dzo.com.ua',
  USERS_API: 'https://test-user.dzo.com.ua',
  TRANSLATIONS_URL: 'https://d38lro0afreoj3.cloudfront.net',
  PROZORRO: 'https://sandbox.prozorro.gov.ua',
  AUCTIONS_PROZORRO: 'https://auction-sandbox-2.prozorro.gov.ua',
  PROZORRO_API_LINK: 'https://public-api-sandbox-2.prozorro.gov.ua/api/2.5',
  OLD_DZO: 'https://test.dzo.com.ua',
  FILES: 'https://test.dzo.com.ua/newdzo/assets/files',
  NEWS: 'https://news.dzo.com.ua',
  CALLME: 'https://binotel.dzo.com.ua',
  MESSAGES: 'https://test.dzo.com.ua/files/messages.json',
  defaultLanguage: 'uk',
  languages: {
    uk: {
      label: 'Укр'
    },
    en: {
      label: 'Eng'
    }
  },
  ENABLE_GOOGLE_TAG_MANAGER: false,
  GOOGLE_TAG_ID: 'G-P9Q3FG735B',
  ENABLE_CABINET: true
}
